import axios from 'axios';
import { HistoryEntry, IdsEcoaColumn, IdsEcoaRow, IdsEcoaSkippedRow, SaveResponse } from './types';

type FetchResponse = {
  success: boolean;
  data: {
    columns: IdsEcoaColumn[];
    rows: IdsEcoaRow[];
    updated_at?: string | null;
  };
  error?: string;
};

export async function fetchIdsEcoaApuracao(): Promise<FetchResponse> {
  const { data } = await axios.get<FetchResponse>('/unilever/ids-ecoa-apuracao');
  return data;
}

export async function saveIdsEcoaApuracao(
  rows: IdsEcoaRow[],
  source: 'table' | 'import',
  action: string,
  skippedRows: IdsEcoaSkippedRow[] = []
): Promise<SaveResponse> {
  try {
    const { data } = await axios.put<SaveResponse>('/unilever/ids-ecoa-apuracao', {
      rows,
      source,
      action,
      skippedRows,
    });
    return data;
  } catch (error: any) {
    return error?.response?.data || {
      success: false,
      error: 'Falha na comunicação com o servidor',
    };
  }
}

type RawHistoryResponse = {
  success: boolean;
  data: Array<Omit<HistoryEntry, 'data'> & { data: string | HistoryEntry['data'] }>;
};

export async function fetchIdsEcoaHistory(): Promise<HistoryEntry[]> {
  const { data } = await axios.get<RawHistoryResponse>('/unilever/ids-ecoa-apuracao/history');
  const rows = data?.data || [];

  return rows.map((entry) => {
    let parsed = {};
    try {
      parsed = typeof entry.data === 'string' ? JSON.parse(entry.data || '{}') : entry.data || {};
    } catch {
      parsed = {};
    }

    return {
      ...entry,
      data: parsed,
    } as HistoryEntry;
  });
}
